export { default } from './EmprestimoGarantiaCarroOQueE';
